$(document).ready(function () {
    let elError;
    // Create the toast error element and append it to body if not already present
    if (isEmpty($("#toastError"))) {
        elError = $("<div id='toastError'>Default message</div>");
        $('body').append(elError);
    }
});

// *** window.showToast ***
window.showToast = function (message, state) {
    let element = $("#toastError");
    if (isEmpty(element)) {
        ontech.log.error(`toast element "toastError" not found`);
        return;
    }

    if (message) {
        element.html(message);
    }

    switch (state){
        case 'error':
            element.addClass("error");
            break;
        case 'success':
            element.addClass("success");
            break;
        case 'warning':
            element.addClass("warning");
            break;
    }

    element.addClass("show");

    setTimeout(function () {
        hideElement(element, false);
        element.removeClass();
    }, 3000);
};
